import { FC } from 'react'
import { MuiThemeProvider } from '@material-ui/core'
import MUIDataTable, { MUIDataTableColumnDef, MUIDataTableOptions } from 'mui-datatables'
import { createTheme } from '@material-ui/core/styles'

type Props = {
    data: any
    columns: MUIDataTableColumnDef[]
    title: string
    customOptions?: MUIDataTableOptions
}
const BasicTable: FC<Props> = ({ data, columns, title, customOptions }) => {

    let timeout: any = null
    const defaultOptions: MUIDataTableOptions = {
        elevation: 0,
        serverSide: false,
        selectableRows: 'none',
        pagination: true,
        download: false,
        print: false,
        filter: false
    };

    const options = { ...defaultOptions, ...customOptions };
    const getMuiTheme = () => createTheme({
        overrides: {
            MUIDataTableBodyCell: {
                root: {
                    fontSize: 14,
                }
            },
            MuiTableBody: {
                root: {
                    resize: 'block'
                }
            }
        }
    })
    return (
        <MuiThemeProvider theme={getMuiTheme()}>
            <MUIDataTable
                data={data}
                title={title}
                columns={columns}
                options={options}
            />
        </MuiThemeProvider>
    )
}

export { BasicTable }